import React from "react";

export const Partner = () => {
  return (
    <div className="partners pb-3 mt-3">
      <div className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-center">
        <img src="/images/rippling2.svg.png" alt="" />
        <img src="/images/cartrawler.svg.png" alt="" />
        <img src="/images/sorare.svg.png" alt="" />
      </div>
      {/* <div className="text-center d-flex align-items-center justify-content-center mt-4">
        <h2 className="text-gradient fs-5">
          Global leaders trust Stabulot to secure their most <br />
          sensitive payment data
        </h2>
      </div> */}
    </div>
  );
};
